import axios from 'axios'

// 获取物品列表
export function getItemList(params) {
  // 后端期望参数：pageNum, pageSize, keyword, typeId
  return axios.get(process.env.VUE_APP_BASE_API + '/item/list', { params })
}

// 获取单个物品（可选）
export function getItem(id) {
  return axios.get(process.env.VUE_APP_BASE_API + `/item/get/${id}`)
}

// 新增物品
export function addItem(data) {
  return axios.post(process.env.VUE_APP_BASE_API + '/item/add', data)
}

// 修改物品
export function updateItem(data) {
  return axios.post(process.env.VUE_APP_BASE_API + '/item/update', data)
}

// 删除物品（POST）
export function deleteItem(id) {
  return axios.post(process.env.VUE_APP_BASE_API + `/item/delete/${id}`)
}

export default {
  getItemList,
  getItem,
  addItem,
  updateItem,
  deleteItem
}
